package com.happyukrainian.revision.kweb.components

import androidx.compose.runtime.Composable
import com.happyukrainian.revision.kweb.config.ButtonStyle
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.percent

@Composable
fun NavigationRail(
    currentCard: Int,
    totalCards: Int,
    onPrevious: () -> Unit,
    onNext: () -> Unit,
) {
    Column(modifier = Modifier.width(100.percent)) {
        Box(modifier = Modifier.fillMaxSize().styleModifier { property("position", "relative") }) {
            Row(modifier = Modifier.fillMaxSize(), verticalAlignment = Alignment.CenterVertically) {
                if (currentCard > 0) {
                    Button(onClick = { onPrevious() }, ButtonStyle.toModifier()) {
                        SpanText("←")
                    }
                }
                Spacer()
                if (currentCard < totalCards) {
                    Button(onClick = { onNext() }, ButtonStyle.toModifier()) {
                        SpanText("→")
                    }
                }
            }

            Box(modifier = Modifier.styleModifier {
                property("position", "absolute")
                property("top", "0")
                property("left", "0")
                property("width", "100%")
                property("height", "100%")
                property("display", "flex")
                property("align-items", "center")
                property("justify-content", "center")
                property("pointer-events", "none")
            }) {
                SpanText("${currentCard + 1} / ${totalCards + 1}")
            }
        }
    }
}
